var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriendWoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "50px",
    viewBox: "0 0 74 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1E69C084-7B0E-4364-835C-8F26D331FE12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-what-can-help",
    transform: "translate(-354.000000, -692.000000)",
    strokeWidth: 2.52
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(356.000000, 694.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.116962,26.196282 L6.697422,26.975502 C6.697422,26.975502 1.319202,28.001142 0.807642,31.969782 L-1.8e-05,45.895302",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.300438,26.196282 L31.737798,27.034182 C31.737798,27.034182 37.116918,28.060002 37.628658,32.030622 L38.435238,45.893142",
    id: "Stroke-3",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.31721,21.14856 L31.31721,12.70728 C31.14315,-0.9027 19.19871,0.01278 19.19871,0.01278 C19.19871,0.01278 7.25427,-0.9027 7.08039,12.70728 L7.08039,21.14856",
    id: "Stroke-5",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.504582,13.322772 C12.504582,18.591732 15.692742,23.936292 19.284822,23.936292 C22.917762,23.936292 25.678062,18.591732 25.678062,13.322772 C25.678062,13.322772 25.879482,9.855432 24.114222,7.595532 C24.114222,7.595532 19.482102,12.444912 7.534422,13.116132",
    id: "Stroke-7",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.100138,26.196282 L63.536418,27.034182 C63.536418,27.034182 68.916438,28.060002 69.428358,32.030622 L70.233858,45.893142",
    id: "Stroke-9",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#ED7330",
    points: "42.928092 26.197344 50.999472 40.397724 59.100192 26.196264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.116928,21.14856 L63.116928,12.70728 C62.942688,-0.9027 50.998428,0.01278 50.998428,0.01278 C50.998428,0.01278 39.053988,-0.9027 38.880108,12.70728 L38.880108,21.14856",
    id: "Stroke-13",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.304102,13.322772 C44.304102,18.591732 47.492442,23.936292 51.083262,23.936292 C54.716382,23.936292 57.476682,18.591732 57.476682,13.322772 C57.476682,13.322772 57.678102,9.855432 55.913922,7.595532 C55.913922,7.595532 51.280542,12.444912 39.333042,13.116132",
    id: "Stroke-15",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-17",
    stroke: "#222456",
    points: "11.116962 26.196282 19.200762 40.397562 27.300402 26.196282"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendWoman);
export default __webpack_public_path__ + "static/media/friendWoman.11c626a3.svg";
export { ForwardRef as ReactComponent };